import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ServiceHeader } from './ServiceHeader';
import { ServiceDescription } from './ServiceDescription';
import { ServiceBenefits } from './ServiceBenefits';
import { ConsultationButton } from './ConsultationButton';
import { urlFor } from '@/sanity/client';
import { ServiceData } from '@/types/sanity';
import { ImageCard } from './ImageCard';

interface ServiceDetailsProps {
	service: ServiceData;
}

export default function ServiceDetails({ service }: ServiceDetailsProps) {
	const navigate = useNavigate();

	return (
		<article className='flex flex-col gap-6 text-neutral-800'>
			<button
				onClick={() => navigate('/services')}
				className='self-start px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors'
			>
				← Back to Services
			</button>

			<div className='grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start'>
				{/* First column - Image */}
				<div className='md:col-span-3'>
					<ImageCard
						backgroundImage={urlFor(service.image).url()}
						className='image-card w-full'
					/>
				</div>

				{/* Second column - Service details */}
				<div className='md:col-span-6'>
					<div className='w-full'>
						<ServiceHeader
							title={service.title}
							frequency={service.frequency && service.frequency}
							location={service.location && service.location}
							price={service.price}
							duration={
								service.duration === 0
									? 'Tailored'
									: service.duration + ' ' + service.format
							}
							isPOA={service.isPOA}
							requiresConsultation={service.requiresConsultation}
							consultationPrice={service.consultationPrice}
						/>
						<ServiceDescription
							description={service.description}
							content={service.content}
						/>
						<ServiceBenefits benefits={service.benefits} />
					</div>
				</div>

				{/* Third column - Consultation button */}
				<div className='md:col-span-3 md:self-start md:-mt-5'>
					{service.isBookable ? (
						<ConsultationButton service={service} />
					) : (
						<div className='text-center text-red-500 font-semibold p-4 border border-red-500 rounded-lg'>
							We’ve reached our 1 on 1 coaching capacity for the remainder of
							the year. Booking opens again from 12 Jan 2026.
						</div>
					)}
				</div>
			</div>
		</article>
	);
}
